<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('pickupCardCreation.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('pickupCardCreation.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-flex ts-justify-between">
          <div class="ts-flex">
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'pickup-card-creation-create' })"
              >{{ $t('add_new') }}</ts-button
            >
            <div
              class="ml-2 ts-rounded ts-border ts-px-2 ts-whitespace-no-wrap mr-2"
            >
              <div class="radio radio-css radio-inline">
                <input
                  v-model="side"
                  type="radio"
                  id="front"
                  :value="'front'"
                />
                <label for="front">{{ $t('pickupCardCreation.front') }}</label>
              </div>
              <div class="radio radio-css radio-inline">
                <input v-model="side" type="radio" id="back" :value="'back'" />
                <label for="back">{{ $t('pickupCardCreation.back') }}</label>
              </div>
              <!-- Old Preview Card  -->
              <!-- <ts-button
              v-if="true"
              class="btn-sm ml-2 mr-2"
              :disabled="!checkedGuardian.length > 0"
              outline
              color="primary"
              @click="previewCard('simple')"
            >
              {{ $t('pickupCardCreation.previewCard') }}
            </ts-button> -->
            </div>
            <!-- New Preview Card -->
            <div class="ts-mr-2" v-if="true">
              <b-dropdown
                dropdown
                :text="
                  $t(
                    'school.academic.operation.profile_mgt.studentProfile.previewCard'
                  )
                "
                variant="outline-primary"
                :disabled="!checkedGuardian.length > 0"
              >
                <b-dropdown-item
                  :disabled="!checkedGuardian.length > 0"
                  href="#"
                  @click="previewCard('simple')"
                >
                  <i class="fas fa-print"></i>
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.simplePrinter'
                    )
                  }}
                </b-dropdown-item>
                <b-dropdown-item
                  :disabled="!checkedGuardian.length > 0"
                  href="#"
                  @click="previewCard('pro')"
                >
                  <i class="fas fa-id-card"></i>
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.proPrinter'
                    )
                  }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
            <div class="ts-flex-grow"></div>
            <div class="mr-2">
              <ts-input
                v-model="search"
                :placeholder="$t('search')"
                style="width: 300px"
              />
            </div>
            <b-dropdown
              dropdown
              variant="outline-default"
              :waiting="exporting"
              no-caret
              right
            >
              <template v-slot:button-content>
                <i class="fas fa-align-justify"></i>
              </template>
              <b-dropdown-item
                @click="
                  $router.push({ name: 'pickup-card-creation-card-by-class' })
                "
              >
                <i class="fas fa-address-card"></i>
                {{ $t('pickupCardCreation.cardByClass') }}
              </b-dropdown-item>
              <b-dropdown-item href="#" @click.prevent="() => (visible = true)">
                <i class="fas fa-filter"></i>
                {{ $t('pickupcardcreation.filter') }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-loading-banner :loading="exporting">
          <Table
            row-key="index"
            :columns="columns"
            :data="groupResources"
            :span-method="handleSpan"
            size="small"
            :loading="loading"
            highlight-row
            stripe
            max-height="700"
            ref="selection"
            @on-select="onSelectCheck"
            @on-select-cancel="onSelectUncheck"
            @on-select-all="onSelectAllCheck"
            @on-select-all-cancel="onSelectAllUncheck"
          >
            <template slot-scope="{ row }" slot="branch_name_en">
              {{ row.branch ? row.branch.branch_name_en : '' }}
            </template>
            <template slot-scope="{ row }" slot="photo">
              <img
                class="height-30 ts-rounded"
                v-lazy="{
                  src: guardianPhoto(row),
                  error: onError(row),
                  loading: require('@/assets/Rolling-1s-200px_2.svg')
                }"
              />
            </template>
            <template
              slot-scope="{ row }"
              slot="printer_counter"
              class="ts-text-center"
            >
              <a-popconfirm
                placement="leftTop"
                :title="$t('are_you_sure_to_increase')"
                :ok-text="$t('yes')"
                :cancel-text="$t('no')"
                @confirm="increase(row)"
              >
                <a
                  href="#"
                  class="ts-border ts-rounded-full ts-px-2 ts-h-1 ts-bg-teal-500 ts-text-white"
                >
                  <i class="fas fa-circle-notch spin" v-if="row._deleting"></i>
                  <span v-else>
                    {{ row.printer_counter ? row.printer_counter : 0 }}
                  </span>
                </a>
              </a-popconfirm>
            </template>
            <template slot-scope="{ row }" slot="action">
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="mr-2 text-primary"
                @click.prevent="edit(row)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('delete')"
                class="text-danger mr-1"
                @click.prevent="showDeleteForm(row)"
                :disabled="row._deleting"
              >
                <i class="fas fa-circle-notch spin" v-if="row._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>

              <Dropdown
                trigger="click"
                v-tooltip="$t('pickupCardCreation.card')"
                style="margin-left: 10px"
                @on-click="name => card(row, 'front')"
              >
                <i class="fas fa-id-card text-primary"></i>
                <DropdownMenu slot="list">
                  <DropdownItem name="front"
                    ><i class="fas fa-address-card text-primary"></i>
                    {{ $t('pickupCardCreation.frontCard') }}</DropdownItem
                  >
                  <DropdownItem name="back" @click="card(row, 'back')"
                    ><i class="far fa-credit-card text-primary"></i>
                    {{ $t('pickupCardCreation.backCard') }}</DropdownItem
                  >
                </DropdownMenu>
              </Dropdown>
            </template>
          </Table>
        </ts-loading-banner>
      </div>
      <div class="d-flex justify-content-between align-items-center p-15">
        <ts-total-list v-model="pagination" />
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <a-drawer
        :title="$t('invoice.filter')"
        placement="right"
        :closable="false"
        :visible="visible"
        @close="() => (visible = false)"
        :zIndex="1020"
        width="300px"
      >
        <div class="row">
          <legend class="text-black ts-text-sm">
            {{ $t('studentprofile.printCard') }}
          </legend>
          <div class="form-group">
            <div class="radio radio-css radio-inline is-valid">
              <input
                v-model="is_print_card"
                type="radio"
                id="printedCard"
                :value="1"
              />
              <label for="printedCard">
                {{ $t('studentprofile.printedCard') }}
              </label>
            </div>
            <div class="radio radio-css radio-inline is-invalid">
              <input
                v-model="is_print_card"
                type="radio"
                id="no_print_card"
                :value="2"
              />
              <label for="no_print_card"
                >{{ $t('studentprofile.notYetPrintCard') }}
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="ts-text-xs">
                {{ $t('studentprofile.branch') }}
              </label>
              <a-select
                style="width: 257px"
                v-model="branch_id"
                :options="branchs"
                showSearch
                mode="multiple"
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
                :maxTagCount="1"
                :maxTagTextLength="17"
                :placeholder="$t('all')"
              >
              </a-select>
            </div>
          </div>
        </div>
        <div class="row">
          <ts-button class="btn-block" @click.prevent="clearFilter">
            <i class="far fa-times-circle"></i>
            {{ $t('studentprofile.clearFilter') }}
          </ts-button>
        </div>
      </a-drawer>
    </ts-card>
  </div>
</template>
<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import DeleteComponent from './delete'
import PreviewCard from './preview-card'
import iTable from '@/store/i-table-helper'
import DownloadTable from './components/download-table.vue'
export default {
  name: 'pickup-card-creation',
  data() {
    return {
      visible: false,
      loading: false,
      exporting: false,
      checkedGuardian: [],
      branchs: [],
      side: 'front',
      manPhoto: require('../../assets/staff-default-man.png'),
      womenPhoto: require('../../assets/staff-default-women.png'),
      defaultPhoto: require('../../assets/user_default.png')
    }
  },
  created() {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.fetchData()
    this.getBranch()
  },
  computed: {
    ...mapState('pickupCardCreation', ['resources', 'pagination']),
    groupResources() {
      return iTable.rowGroup(this.resources, 'student.full_name_en')
    },
    columns() {
      return [
        {
          key: 'column_name',
          tree: true,
          maxWidth: 15,
          className: 'text-primary bold'
        },
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: this.$t('pickupCardCreation.branch'),
          minWidth: 100,
          slot: 'branch_name_en'
        },
        {
          title: this.$t('pickupCardCreation.photo'),
          minWidth: 100,
          slot: 'photo'
        },
        {
          title: this.$t('pickupCardCreation.cardNumber'),
          minWidth: 100,
          key: 'card_number'
        },
        {
          title: this.$t('pickupCardCreation.nameEn'),
          key: 'guardian',
          minWidth: 120
        },
        {
          title: this.$t('pickupCardCreation.nameKh'),
          key: 'guardian_kh',
          minWidth: 120
        },
        {
          title: this.$t('pickupCardCreation.relationship'),
          key: 'relationship',
          align: 'center',
          minWidth: 100
        },
        {
          title: this.$t('pickupCardCreation.phoneNumber'),
          align: 'center',
          key: 'contact_no',
          minWidth: 120
        },
        {
          title: this.$t('pickupCardCreation.issuedDate'),
          align: 'center',
          key: 'issued_date',
          minWidth: 100
        },
        {
          title: this.$t('pickupCardCreation.expiryDate'),
          align: 'center',
          key: 'expiry_date',
          minWidth: 100
        },
        {
          title: this.$t('pickupCardCreation.printCounter'),
          align: 'center',
          slot: 'printer_counter',
          minWidth: 80
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 100
        }
      ]
    },
    search: {
      get() {
        return this.$store.state.pickupCardCreation.search
      },
      set(newValue) {
        this.$store.commit('pickupCardCreation/SET_SEARCH', newValue)
        this.$store.commit('pickupCardCreation/RESET_CURRENT_PAGE')
      }
    },
    is_print_card: {
      get() {
        return this.$store.state.pickupCardCreation.is_print_card
      },
      set(newValue) {
        this.$store.commit('pickupCardCreation/SET_IS_PRINT_CARD', newValue)
      }
    },
    branch_id: {
      get() {
        return this.$store.state.pickupCardCreation.branch_id
      },
      set(newValue) {
        this.$store.commit('pickupCardCreation/SET_BRANCH_ID', newValue)
      }
    }
  },
  methods: {
    fetchData(attributes = {}) {
      this.loading = true
      this.$store
        .dispatch(
          'pickupCardCreation/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(errors => {
          this.loading = false
          this.$toasted.error(errors.message)
        })
    },
    getBranch() {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    increase(record) {
      record._deleting = true
      this.$store
        .dispatch(
          'pickupCardCreation/increaseCounter',
          record.student_pickup_id
        )
        .then(() => {
          record.printer_counter = parseInt(record.printer_counter, 10) + 1
          this.loading = false
        })
        .catch(errors => {
          this.$toasted.error(errors.message)
        })
        .finally(() => {
          record._deleting = false
        })
    },
    edit(record) {
      this.$store.commit('pickupCardCreation/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'pickup-card-creation-edit',
        params: { id: record.student_pickup_id }
      })
    },
    showDeleteForm(data) {
      this.$modal.show(
        DeleteComponent,
        {
          data: data
        },
        {
          height: 'auto',
          width: '300px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    previewCard(type) {
      if (type == 'pro') {
        this.$modal.show(
          DownloadTable,
          {
            id_list: this.checkedGuardian,
            side: this.side,
            type: type
          },
          {
            height: 'auto',
            width: '70%',
            scrollable: true,
            draggable: '.form-header',
            clickToClose: false
          }
        )
        return
      } else {
        this.$modal.show(
          PreviewCard,
          {
            id_list: this.checkedGuardian,
            side: this.side,
            type: type
          },
          {
            height: 'auto',
            width: '70%',
            scrollable: true,
            draggable: '.form-header',
            clickToClose: false
          }
        )
      }
    },
    card(record, side) {
      this.checkedGuardian = []
      this.checkedGuardian.push(record.student_pickup_id)
      this.side = side
      this.previewCard()
      this.checkedGuardian = []
    },
    guardianPhoto(record) {
      if (record.photo) {
        return record.photo
      }
      if (record.relationship == 'Father') {
        return this.manPhoto
      }
      if (record.relationship == 'Mother') {
        return this.womenPhoto
      }
      if (record.relationship == 'Other') {
        return this.defaultPhoto
      }
    },

    onError(record) {
      event
        ? (event.target.src =
            record.relationship == 'Father' ? this.manPhoto : this.womenPhoto)
        : ''
    },
    onSelectCheck(selection, row) {
      if (!this.checkedGuardian.includes(row.student_pickup_id)) {
        this.checkedGuardian.push(row.student_pickup_id)
      }
      // this.setStudentListSelected(record)
    },
    onSelectUncheck(selection, row) {
      this.checkedGuardian = this.checkedGuardian.filter(
        key => key !== row.student_pickup_id
      )
      // this.setStudentListSelected(record)
    },
    onSelectAllCheck(record) {
      this.setStudentListSelected(record)
    },
    onSelectAllUncheck(record) {
      this.checkedGuardian = []
      // this.setStudentListSelected(record)
    },
    handleSelectAll(status) {
      this.$refs.selection.selectAll(status)
    },
    handleSelectionChange(checkedGuardian, selectedRows) {
      this.checkedGuardian = checkedGuardian
    },
    checkItem(value) {
      this.checkedGuardian = []
      if (records.length > 0) {
        records.map(row => {
          this.checkedGuardian.push(row.student_pickup_id)
        })
      }
    },
    clearFilter() {
      this.is_print_card = null
    },
    handleSpan({ row, column, rowIndex, columnIndex }) {
      return iTable.handleSpan(row, columnIndex, this.columns)
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({
        search,
        branch_id: this.branch_id
      })
    }, 500),
    is_print_card: debounce(function(search) {
      this.fetchData({ search })
    }, 500),
    branch_id: debounce(function(value) {
      this.fetchData({ branch_id: value })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('pickupCardCreation/RESET_STATE')
    next()
  }
}
</script>
<style lang="css">
.bold {
  font-weight: bold;
}
</style>
